"use strict";

import { lcvPrizePotConstants } from "../_constants/lcvPrizePot.constants";

export const INITIAL_LCV_PRIZE_POT_STATE = {
     prizePot : null,
     actionResult : null,
     budgetActivity : { entries: [], authorisedGbp: 0, committedGbp: 0 },
};

export function lcvPrizePot(state = INITIAL_LCV_PRIZE_POT_STATE, action) {
    switch (action.type) {
     // The BFF unwraps the gateway envelope, so the payload is already the bare result.
     case lcvPrizePotConstants.LCV_PRIZE_POT_GET_COMPLETE:
          return {
               ...state,
               prizePot: action.payload || null,
          };
     // Both writes answer with a message and nothing else, so they share one slot and the screen
     // reloads the pot rather than patching a row it did not calculate.
     case lcvPrizePotConstants.LCV_PRIZE_POT_SET_AVAILABILITY_COMPLETE:
     case lcvPrizePotConstants.LCV_PRIZE_POT_INCREASE_QUANTITY_COMPLETE:
     case lcvPrizePotConstants.LCV_PRIZE_POT_ADD_BUDGET_ENTRY_COMPLETE:
          return {
               ...state,
               actionResult: action.payload || null,
          };
     case lcvPrizePotConstants.LCV_PRIZE_POT_CLEAR_ACTION_RESULT:
          return {
               ...state,
               actionResult: null,
          };
     case lcvPrizePotConstants.LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_COMPLETE:
          return {
               ...state,
               budgetActivity: action.payload || { entries: [], authorisedGbp: 0, committedGbp: 0 },
          };
     default:
          return state;
    }
}
